<div>
  <form [formGroup]="creditTermForm">

    <!-- Customer row -->
    <mat-card-content class="credit-row">
      <div class="check-size">
        <mat-checkbox formControlName="customerFlag" [disabled]="disableSubmit">Customer</mat-checkbox>
      </div>

      <div *ngIf="showCustomerFields" class="fx-align-space-evenly">
        <mat-form-field appearance="fill" class="days-field" subscriptSizing="dynamic">
          <mat-label>Credit Days</mat-label>
          <input matInput placeholder="e.g. 30" autocomplete="off" inputmode="numeric"
                 formControlName="customerCreditDays" required [disabled]="disableSubmit"
                 (input)="sanitizeIntegerInput($event, customerCreditDays)">
          <mat-error *ngIf="customerCreditDays.touched && customerCreditDays.hasError('required')">Credit Days is required</mat-error>
          <mat-error *ngIf="customerCreditDays.touched && customerCreditDays.hasError('pattern')">Must be a whole number greater than 0</mat-error>
        </mat-form-field>

        <mat-form-field appearance="fill" class="amount-field" subscriptSizing="dynamic">
          <mat-label>Credit Amount</mat-label>
          <input matInput placeholder="e.g. 50000" autocomplete="off" inputmode="decimal"
                 formControlName="customerCreditAmount" required [disabled]="disableSubmit"
                 (input)="sanitizeCurrencyInput($event, customerCreditAmount)">
          <mat-error *ngIf="customerCreditAmount.touched && customerCreditAmount.hasError('required')">Credit Amount is required</mat-error>
          <mat-error *ngIf="customerCreditAmount.touched && customerCreditAmount.hasError('pattern')">Must be a number greater than 0</mat-error>
          <mat-error *ngIf="customerCreditAmount.touched && customerCreditAmount.hasError('belowBranchSum')">
            Credit Amount must be greater than or equal to the sum of all Branch Credit Amounts.
          </mat-error>
        </mat-form-field>

        <mat-form-field appearance="fill" class="currency-field" subscriptSizing="dynamic">
          <mat-label>Currency</mat-label>
          <mat-select formControlName="customerCurrencyId" [disabled]="disableSubmit" required
                      (selectionChange)="onCustomerCurrencySelect($event.value)">
            <mat-option>
              <ngx-mat-select-search [searching]="searching" [formControl]="currencySearchCtrl"
                placeholderLabel="Search currency..." noEntriesFoundLabel="No currency found">
              </ngx-mat-select-search>
            </mat-option>
            <mat-option *ngFor="let curr of filteredCurrency | async" [value]="curr.id">{{curr.name}}</mat-option>
          </mat-select>
          <mat-error *ngIf="customerCurrencyId.touched && customerCurrencyId.hasError('required')">Currency is required</mat-error>
        </mat-form-field>

        <mat-form-field appearance="fill" class="category-field" subscriptSizing="dynamic">
          <mat-label>Customer Category</mat-label>
          <mat-select formControlName="customerCategory" [disabled]="disableSubmit">
            <mat-option *ngFor="let cat of customerCategoryList" [value]="cat">{{cat}}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </mat-card-content>

    <!-- Vendor row -->
    <mat-card-content class="credit-row">
      <div class="check-size">
        <mat-checkbox formControlName="vendorFlag" [disabled]="disableSubmit">Vendor</mat-checkbox>
        <mat-error *ngIf="(customerFlag.touched || vendorFlag.touched) && vendorFlag.hasError('mustRequired')">At least one of Customer or Vendor must be selected</mat-error>
      </div>

      <div *ngIf="showVendorFields" class="fx-align-space-evenly">
        <mat-form-field appearance="fill" class="days-field" subscriptSizing="dynamic">
          <mat-label>Credit Days</mat-label>
          <input matInput placeholder="e.g. 30" autocomplete="off" inputmode="numeric"
                 formControlName="vendorCreditDays" required [disabled]="disableSubmit"
                 (input)="sanitizeIntegerInput($event, vendorCreditDays)">
          <mat-error *ngIf="vendorCreditDays.touched && vendorCreditDays.hasError('required')">Credit Days is required</mat-error>
          <mat-error *ngIf="vendorCreditDays.touched && vendorCreditDays.hasError('pattern')">Must be a whole number greater than 0</mat-error>
        </mat-form-field>

        <mat-form-field appearance="fill" class="amount-field" subscriptSizing="dynamic">
          <mat-label>Credit Amount</mat-label>
          <input matInput placeholder="e.g. 50000" autocomplete="off" inputmode="decimal"
                 formControlName="vendorCreditAmount" required [disabled]="disableSubmit"
                 (input)="sanitizeCurrencyInput($event, vendorCreditAmount)">
          <mat-error *ngIf="vendorCreditAmount.touched && vendorCreditAmount.hasError('required')">Credit Amount is required</mat-error>
          <mat-error *ngIf="vendorCreditAmount.touched && vendorCreditAmount.hasError('pattern')">Must be a number greater than 0</mat-error>
          <mat-error *ngIf="vendorCreditAmount.touched && vendorCreditAmount.hasError('belowBranchSum')">
            Credit Amount must be greater than or equal to the sum of all Branch Credit Amounts.
          </mat-error>
        </mat-form-field>

        <mat-form-field appearance="fill" class="currency-field" subscriptSizing="dynamic">
          <mat-label>Currency</mat-label>
          <mat-select formControlName="vendorCurrencyId" [disabled]="disableSubmit" required
                      (selectionChange)="onVendorCurrencySelect($event.value)">
            <mat-option>
              <ngx-mat-select-search [searching]="searching" [formControl]="currencySearchCtrl"
                placeholderLabel="Search currency..." noEntriesFoundLabel="No currency found">
              </ngx-mat-select-search>
            </mat-option>
            <mat-option *ngFor="let curr of filteredCurrency | async" [value]="curr.id">{{curr.name}}</mat-option>
          </mat-select>
          <mat-error *ngIf="vendorCurrencyId.touched && vendorCurrencyId.hasError('required')">Currency is required</mat-error>
        </mat-form-field>

        <mat-form-field appearance="fill" class="category-field" subscriptSizing="dynamic">
          <mat-label>Vendor Category</mat-label>
          <mat-select formControlName="vendorCategory" [disabled]="disableSubmit">
            <mat-option *ngFor="let cat of vendorCategoryList" [value]="cat">{{cat}}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </mat-card-content>

  </form>
</div>
